// libs
import React from 'react';
import once from 'lodash/once';

import { AddBlock, LargeAddBlock } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
// components
import { Box } from '@lyearn/ui';
import { SearchBarWithCount } from '@/components/SearchBar';

import Items from './components/Items';
// types
import { ListProps } from './types';

interface ListContextValue<T> {
  items?: T[];
  fetchMore?: () => void;
}

const createListContext = once(<T,>() => React.createContext<ListContextValue<T>>({}));

const useListContext = <T,>() => {
  const value = React.useContext(createListContext<T>());

  if (!value) {
    throw new Error('[ListContext] Not initialised');
  }

  return value;
};

function List<T>(props: ListProps<T>) {
  const { items, fetchMore } = props;
  const ListContext = createListContext<T>();

  return (
    <ListContext.Provider
      value={{
        items,
        fetchMore,
      }}>
      <Box className={cn(props.className)}>{props.children}</Box>
    </ListContext.Provider>
  );
}

export {
  AddBlock,
  Items,
  LargeAddBlock,
  List as Provider,
  SearchBarWithCount as Search,
  useListContext,
};
